import styled from 'styled-components';
import { RangeNumberProps } from './types';
import { getRadius } from './utils';
import { SCORE_SIZE } from './constants';

export const TextHolder = styled.div`
  display: flex;
  gap: 12px;
`;

export const StyledRange = styled.div<any>`
  margin: 24px 0 0px 0;
  width: 100%;
  max-width: 720px;
  .m-s-b-s-q-r-widget {
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;
    .m-s-b-s-q-r-boolean {
      display: flex;
    }
    .m-s-b-s-q-r-holder {
      margin-right: 32px;
      width: unset;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .emoji-svg-false {
    & > path {
      &:first-child {
        fill: ${({ button_style }) =>
          button_style === 'standard' ? '#F9DB8C' : ''};
      }
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5),
      &:nth-child(6),
      &:last-child {
        fill: ${({ button_style }) =>
          button_style === 'standard' ? '#000000' : ''};
      }
    }

    &.smiley-1 > path {
      &:nth-child(6),
      &:nth-child(7),
      &:nth-child(8),
      &:nth-child(9) {
        fill: ${({ button_style }) =>
          button_style === 'standard' ? '#4485c6' : ''};
      }
    }

    &.smiley-2 > path {
      &:last-child {
        fill: ${({ button_style }) =>
          button_style === 'standard' ? '#4485c6' : ''};
      }
    }

    &.smiley-10 > path {
      &:nth-child(2),
      &:nth-child(3) {
        fill: ${({ button_style }) =>
          button_style === 'standard' ? '#ce2829' : ''};
      }
    }
  }

  .m-s-b-s-q-r-footer {
    border-top: 1px solid var(--color-smoke-50);
    padding-top: 20px;
    display: flex;
    justify-content: center;
    font-size: 14px;

    .c-editable-input-text {
      white-space: break-spaces;
    }
  }
`;

export const RangeNumber = styled.div<RangeNumberProps>`
  --default-brand-color: ${({ brandColor }) => brandColor || '#E50914'};
  width: ${SCORE_SIZE}px;
  height: ${SCORE_SIZE}px;
  font-size: 16px;
  display: grid;
  place-content: center;
  font-weight: 600;
  color: ${({ showBrandColor }) =>
    showBrandColor ? 'white' : 'rgb(58, 75, 103)'};
  border-radius: ${({ question }) =>
    getRadius(
      question?.type_info?.scale_properties?.button_style?.shape || 'square',
    )};
  background-color: ${({ showBrandColor }) =>
    showBrandColor ? 'var(--default-brand-color)' : '#e0e0e0'};
`;

export const LabelText = styled.div`
  margin-top: 12px;
  font-weight: 400;
  color: 'unset';
  font-size: 12px;
  text-align: center;
  max-width: 75px;
  span.r-q-text {
    width: fit-content;
    translate: -50%;
  }
`;

export const TextLabel = styled.div<RangeNumberProps>`
  --default-brand-color: ${({ brandColor }) => brandColor || '#E50914'};
  padding: 15px 20px;
  margin-top: 16px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  width: fit-content;
  color: ${({ showBrandColor }) =>
    showBrandColor ? 'white' : 'rgb(58, 75, 103)'};

  border-radius: ${({ question }) =>
    getRadius(
      question?.type_info?.scale_properties?.button_style?.shape || 'curved',
    )};
  background-color: ${({ showBrandColor }) =>
    showBrandColor ? 'var(--default-brand-color)' : '#e0e0e0'};
`;
